import { Col, Form, Input, InputNumber, Row, Select } from 'antd';
import { useEffect, useRef, useState } from 'react'
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import antMessage from '../../../utils/extend/AntdNotification';
import systemConfig from '../../../config/systematic';
import fetchApi from '../../../utils/api/fetchApi';
import getList from '../../universal/getList';

export default function UnitConversionEdit(props: any) {

    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);

    /**单位数据 */
    const [productUnitData, setProductUnitData] = useState<any>();

    const [productUnit, setProductUnit] = useState<any>();

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
            ref.current.row.then(async (res: any) => {

                if (typeof res === 'undefined') { return }
                if (res.success === true) {
                    if (data.type === "EDIT") {
                        setProductUnit(res.data.productUnit.productUnitName);
                    }
                }
            })
        }
        const fetchData = async () => {
            form.setFieldsValue({ productId: data.sendPageData.productId });

            fetchApi.GET(wmService, {
                apiId: "productUnit",
                apiExtend: 'showList'
            }).then(res => {
                setProductUnitData(res.data)
            })
        }
        fetchData()
    }, [])

    //触发选择单位
    const productUnitChange = (e: any) => {
        if (e === data.sendPageData.productUnitId) {
            form.setFieldsValue({ productUnitId: null });
            antMessage('error', '请不要选择与自身一样的单位！');
        }
        else {
            form.setFieldsValue({ productUnitId: e });
        }
    }

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };

    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'unitConversion'
    };

    return (
        <>
            <WebEditUniversal ref={ref} props={extendProps} />

            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '单位换算'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
            >
                <Form
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                >
                    <Row gutter={[16, 0]}>
                        <Col span={0}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                label="productId"
                                name="productId">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="单位换算"
                                name="conversionFactor"
                                rules={[{ required: true, message: '请输入单位换算系数!' }]}>
                                <InputNumber addonBefore={"1 " + data.sendPageData.productUnitName + " = "} addonAfter={productUnit ? productUnit : <Select
                                    showSearch
                                    style={{ width: 100 }}
                                    onChange={productUnitChange}
                                    placeholder="选择单位"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(productUnitData, 'productUnitName')}
                                </Select>} />
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                // label="单位"
                                name="productUnitId"
                                rules={[{ required: true, message: '请输入单位!' }]}>
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}